import { FC } from "react";
import { IconPropsType } from ".";

export const Warning: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.43302 2.24404C6.60027 0.314197 9.39973 0.314198 10.567 2.24404L14.7727 9.19738C15.982 11.1968 14.5423 13.75 12.2057 13.75H3.79432C1.45767 13.75 0.018033 11.1968 1.22734 9.19738L5.43302 2.24404Z"
        fill={props.color}
      />
      <rect x="7" y="3" width="2" height="6" rx="1" fill={"#fff"} />
      <rect x="7" y="10" width="2" height="2" rx="1" fill={"#fff"} />
    </svg>
  );
};
